import axios, { type AxiosResponse } from '@fs/zion-axios'
import { FS_CHAT_SERVICE as SERVICE } from '../../serviceNames'

// DOCS: https://integration.familysearch.org/service/fs-chat/api/resource_ApprovalEndpointsV2.html

const BASE = `${SERVICE}/v2/approval/channels`

/** Checks if the calling user can create/modify channel memberships for the provided cisIds (max 10). */
export function submitUserApproval(
  data: { cisIds: string[] },
  forceForbidden = false
): Promise<AxiosResponse | undefined> {
  return axios
    .post(`${BASE}/membership`, data, {
      params: {
        forceForbidden,
      },
    })
    .catch((error) => {
      return error.response
    })
}
